import React, {ReactElement} from 'react';
import DeleteIcon from '@assets/images/medops/delete.svg';
import {useTranslation} from 'react-i18next';
const Delete = (props: any): ReactElement => {
  const {t} = useTranslation();
  return (
    <img
      src={DeleteIcon}
      height={24}
      width={24}
      {...props}
      alt={t('CLINICS.CLINIC_DETAILS_CARD.DELETE')}
    />
  );
};
export default Delete;
